
import React, {useEffect, useState} from 'react';
import { isViewVisible } from "../../../../utils/ViewSettings";
import {Biscuit, Notification} from "../../../../utils";
import t from '../../../helpers/t';
import InsurancesSidebar from '../components/InsurancesSidebar';
import {insurancesActions, paymentsActions, useSelector} from 'inbooma-api';
import InsurancesList from './InsurancesList';
import InboomaSubmenu from '../../../components/InboomaSubmenu';
import SortNav from '../../../components/SortNav';
import {$, _} from "../../../../../vendor";
import Paginator from "../../../components/paginator";

const InsurancesView = (props) => {

    let language = Biscuit.get('user.lang').replace('-','_');
    const [initialized,setInitialized] = useState(false);
    const [filter,setFilter] = useState({});
    const [sort,setSort] = useState({
        sort: "created",
        direction: "desc"
    });
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const paginationLimit = 100;
    const [insurances,setInsurances] = useState([]);
    const [insurancesPending,setInsurancesPending] = useState(false);
    const _insurances = useSelector(state => state.insurances_data.insurances);

    useEffect(() => {
                if (_insurances.success === "" || !insurancesPending) {
                  return;
                }
                if (_insurances.success === true) {
                        setInsurances(_insurances.data);
                        setPagination({..._insurances.pagination});

                    //setPagination({..._salesBillings.pagination});
                } else {
                  console.log("Failed fetching insurances!");
                }
                setInsurancesPending(false);
    },[_insurances]);


    const filterChangedHandle = (filter) => {

        let requestFilter = {...filter};
        requestFilter.sort = sort.sort;
        requestFilter.direction = sort.direction;
        requestFilter.limit = paginationLimit;
        requestFilter.page = 1;

        props.dispatch(insurancesActions.getInsurances({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setInsurancesPending(true);
        setFilter(filter);
    };

    const onSortChangedHandle = (ev) => {
        const el = ev.currentTarget;

        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let requestFilter;
            if(typeof filter.limit !== 'undefined') {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction
                };
            } else {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction,
                    limit: paginationLimit,
                    page: 1
                };
            }

            props.dispatch(insurancesActions.getInsurances({
                token: Biscuit.get('token'),
                suffix: "",
                filter: requestFilter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setInsurancesPending(true);
            setSort({
                sort: sortKey,
                direction: direction
            });

            const activeSortTab = $('.is-active');
            _.each(activeSortTab, function(key,value){
                key.classList.remove('is-active');
            });
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const showNotification = (msgType, itemId, errorMsg ='',type='order') => {

        if (msgType === 'success') {
            new Notification({
                message : t('saved_${a}',{a:t(type)},'capital')+' #'+ itemId,
                duration : 5000,
                type : 'success',
                closeable : true,
                icon : 'fi fi-check'
            });
        } else if (msgType === 'warning') {
            new Notification({
                message : errorMsg,
                duration : 5000,
                type : 'warning',
                closeable : true,
                icon : 'fi fi-x'
            });
        }
    };

    const initialize = () => {

        props.dispatch(insurancesActions.getInsurances({
            token: Biscuit.get('token'),
            suffix: "",
            filter: {
                sort: sort.sort,
                direction: sort.direction,
                limit: paginationLimit,
                page: 1
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));  
        setInsurancesPending(true);
        setInitialized(true);
    };

    if (initialized === false) initialize();

    const submenuItems = [
        {
          name: t('transactions',null,'capital'),
          link: 'finances/transactions',
          data_inb_val: t('transactions',null,'capital'),
          icon: 'fi fi-dollar',
          isActive: false,
          isAccessible: isViewVisible('transactions','finances')
        },{
            name: t('sales_billings',null,'capital'),
            link: 'finances/sales_billings',
            data_inb_val: t('sales_billings',null,'capital'),
            icon: 'fi fi-list',
            isActive: false,
            isAccessible: isViewVisible('salesBillings','finances')
        },{
            name: t('payment_accounts',null,'capital'),
            link: 'finances/payment_accounts',
            data_inb_val: t('payment_accounts',null,'capital'),
            icon: 'fi fi-list',
            isActive: false,
            isAccessible: false && isViewVisible('paymentAccounts','finances')
        },{
            name: t('insurances',null,'capital'),
            link: 'finances/insurances',
            data_inb_val: t('insurances',null,'capital'),
            icon: 'fi fi-list',
            isActive: true,
            isAccessible: true
        },{
            name: t('admin transactions',null,'capital'),
            link: 'finances/admin_transactions',
            data_inb_val: t('admin transactions',null,'capital'),
            icon: 'fi fi-list',
            isActive: false,
            isAccessible: (Biscuit.get('user.is_superuser')  === 'true')
        },{
            name: t('invoices',null,'capital'),
            link: 'invoices',
            data_inb_val: t('invoices',null,'capital'),
            icon: 'fi fi-list',
            isActive: false,
            isAccessible: (Biscuit.get('user.is_superuser')  === 'true')
        }
    ];

    let tabs =[{
        name: t('created',null,'capital'),
        smallWidth: 2,
        mediumWidth: 1,
        title: t('sort_by_${a}',{a:t('created')},'capital'),
        canSort: true,
        sort: {
          direction: 'desc',
          data_inb_val: 'created'
        }
      },{
        name: t('name',null,'capital'),
        smallWidth: 2,
        mediumWidth: 1,
        title: t('name',null,'capital'),
        canSort: true,
        sort: {
            direction: 'desc',
            data_inb_val: 'name'
        }
      },{
        name: t('description',null,'capital'),
        mediumWidth: 3,
        smallWidth: 6,
        title: t('description',null,'capital'),
        canSort: false
      }, {
        name: t('insurance_provider',null,'capital'),
        smallWidth: 2,
        mediumWidth: 1,
        title: t('insurance_provider',null,'capital'),
        canSort: false,
    }, {
        name: t('subscription',null,'capital'),
        smallWidth: 2,
        mediumWidth: 1,
        title: t('subscription',null,'capital'),
        canSort: false,
      },
        {
            name: t('payment_cycle',null,'capital'),
            smallWidth: 2,
            mediumWidth: 1,
            title: t('payment_cycle',null,'capital'),
            canSort: false,
        },
        {
            name: t('notification_days',null,'capital'),
            smallWidth: 2,
            mediumWidth: 1,
            title: t('notification_days',null,'capital'),
            canSort: false,
        }
    ];

    const loadNextPage = (page) => {

        //if (!pagination.has_next_page) return;

        setInsurancesPending(true);

        let requestFilter = {...filter};
        requestFilter.sort = sort.sort;
        requestFilter.direction = sort.direction;
        requestFilter.limit = paginationLimit;
        requestFilter.page = page;

        // fetch next page
        props.dispatch(insurancesActions.getInsurances({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };


    return (
        <>
            <InsurancesSidebar
                dispatch={props.dispatch}
                heading={t('insurances',null,'capital')}
                filterChangedHandle={filterChangedHandle}/>
            <div id='inb-Inboomasubmenuc-main' className='columns'>
                <InboomaSubmenu
                    tabs={submenuItems}
                    smallOnlyTitle={t('insurances',null,'capital')}
                />
                <SortNav
                    tabs={tabs}
                    listStyle="tight"
                    handler={onSortChangedHandle}/>
                {initialized && insurances.length > 0 && !insurancesPending && typeof pagination !== 'undefined' &&
                    <>
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                    />
                <InsurancesList
                  insurances={insurances}
                  dispatch={props.dispatch}
                  currentUrl={new URL(window.location.href)}
                  showNotification={showNotification}
                />
                        <Paginator
                            pagination={pagination}
                            itemsCountPerPage={paginationLimit}
                            pageRangeDisplayed={5}
                            onChange={loadNextPage}
                        /></>}
            </div>

        </>
    );
};

export default InsurancesView;